// The paperclip on a row that has attachments: the count, and the way into the viewer. A row
// without attachments shows nothing - an empty paperclip on every row would be noise on the one
// column the eye is meant to scan.

import Icon from '../../ui/Icon.jsx';

export default function AttachmentBadge({ row, onOpen }) {
  const count = row.attachment_count ?? 0;
  if (count === 0) return null;
  const label = `${count} ${count === 1 ? 'attachment' : 'attachments'} on ${row.delivery_id}`;
  return (
    <button type="button" className="attachment-badge" onClick={() => onOpen(row)}
            aria-label={label} title={label}>
      <Icon name="paperclip" />
      <span>{count}</span>
    </button>
  );
}
